import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { useAppSelector } from '~redux/hooks';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldTypeEnum } from '~utils/enums';

export default function* watchGetBranchInventoryListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetBranchInventoryListingAttempt', handleGetBranchInventoryListing, api);
}

function* handleGetBranchInventoryListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { branchName } } = reduxState.gold.goldInventoryReport.branchInventory;
    const branchesList = reduxState.branch.allBranches;
    const branchCode = branchesList.find((branch) => branch.branchName === branchName)?.branchCode;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetBranchInventoryListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getBranchInventoryListing], {
        authToken,
        index,
        ...(branchCode && { branchCode }),
        // goldType: GoldTypeEnum.PhysicalGold,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetBranchInventoryListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetBranchInventoryListingSuccess(response.data));
    }
}
